"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

/**
 * Utilities for validating values.
 * @module ValidationUtils
 */
var ValidationUtils = {
  /* eslint-disable quotes, no-useless-escape */

  /**
   * @typedef {String} EMAIL - The email validation regular expression pattern.
   */
  EMAIL: '^(([a-zA-Z0-9!#$%&’*+/=?^_`{|}~-]+(.[a-zA-Z0-9!#$%&’*+/=?^_`{|}~-]+)*)|(".+"))@(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,})$',

  /**
   * @typedef {String} PHONE - The phone validation regular expression pattern.
   */
  PHONE: '^[(]?([0-9]{3})[)]?([-. ])?([0-9]{3})([-. ])?([0-9]{4})$',

  /**
   * @typedef {String} ZIP - The zip validation regular expression pattern.
   */
  ZIP: '^[0-9]{5}(?:-[0-9]{4})?$'
  /* eslint-enable quotes, no-useless-escape */

};
var _default = ValidationUtils;
exports.default = _default;